import { render, staticRenderFns } from "./tdb-dealroom-menu.vue?vue&type=template&id=4aee46d0&scoped=true&"
import script from "./tdb-dealroom-menu.vue?vue&type=script&lang=js&"
export * from "./tdb-dealroom-menu.vue?vue&type=script&lang=js&"
import style0 from "./tdb-dealroom-menu.vue?vue&type=style&index=0&id=4aee46d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aee46d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aee46d0')) {
      api.createRecord('4aee46d0', component.options)
    } else {
      api.reload('4aee46d0', component.options)
    }
    module.hot.accept("./tdb-dealroom-menu.vue?vue&type=template&id=4aee46d0&scoped=true&", function () {
      api.rerender('4aee46d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/menu/tdb-dealroom-menu.vue"
export default component.exports